import {Text, View} from '@react-pdf/renderer';
import styles from '../styles';
import ValidationScoreBoard from './GaugeChart';
import RiskGradeBlock from './RiskGradeBlock';

const RiskSummaryVisualizationSection: React.FC<{
  riskGrade: string;
  riskGaugeScore: number;
}> = ({riskGrade, riskGaugeScore}) => (
  <View style={styles.card}>
    <View style={styles.riskSummaryRow}>
      <View>
        <RiskGradeBlock riskGrade={riskGrade} />
      </View>
      <View style={styles.gaugeBlock}>
        <ValidationScoreBoard score={riskGaugeScore} />
      </View>
      <View style={styles.summaryDivider} />
    </View>

    <Text style={styles.summaryText}>
      نتیجه این ارزیابی بر اساس اطلاعات مزرعه، کشت‌های ثبت شده و داده‌های
      گردآوری شده از منابع گوناگون است.
    </Text>
  </View>
);

export default RiskSummaryVisualizationSection;
